import { render, staticRenderFns } from "./BalanceTabPacks.vue?vue&type=template&id=c8c8fd24&scoped=true&"
import script from "./BalanceTabPacks.vue?vue&type=script&lang=js&"
export * from "./BalanceTabPacks.vue?vue&type=script&lang=js&"
import style0 from "./BalanceTabPacks.vue?vue&type=style&index=0&id=c8c8fd24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c8fd24",
  null
  
)

export default component.exports